'use client';

import '@/utils/fontawesome';
import '@/assets/style/global.css';
import { HeroUIProvider as Provider } from '@heroui/system';
import { useRouter } from 'next/navigation';
// import RouteChangeListener from '@/components/Common/RouteChangeListener';
import React from 'react';
import { usePlan } from '@/features/subscription/hooks/usePlan';
import useAuth from '@/hooks/useAuth';
import { off, on } from '@/utils/emitter';

export default function NextUIProvider({
  children,
}: {
  children: React.ReactNode;
}) {
  const router = useRouter();
  const { user, nextAuthSession } = useAuth();
  const { plan, fetchPlan } = usePlan();

  React.useLayoutEffect(() => {
    on('auth:login-register', (user) => {
      fetchPlan(user);
    });

    return () => off('auth:login-register');
  }, []);

  return (
    <Provider navigate={router.push} className="default-ui-theme">
      {children}
      {/* <RouteChangeListener /> */}
    </Provider>
  );
}
